import { useCallback, useRef } from 'react';
import { TAB_INDEX } from '../pasos';

/**
 * "Ir al paso" del panel de correcciones: cambia de paso y lleva la pantalla
 * hasta la barra de pasos. El panel está arriba del informe, así que sin el
 * scroll el paso cambiaba fuera de la vista y parecía que el botón no hacía
 * nada.
 *
 * El scroll espera al próximo frame para que el contenido del paso nuevo ya
 * esté pintado. El margen contra el AppBar fijo lo da `scroll-margin-top` en
 * el contenedor que recibe `barraPasosRef`.
 */
const useIrAPaso = (cambiarPaso: (paso: TAB_INDEX) => void) => {
    const barraPasosRef = useRef<HTMLDivElement>(null);

    const irAPaso = useCallback(
        (paso: TAB_INDEX) => {
            cambiarPaso(paso);
            requestAnimationFrame(() => {
                barraPasosRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            });
        },
        [cambiarPaso]
    );

    return { barraPasosRef, irAPaso };
};

export default useIrAPaso;
